const TASK_TYPES = {
  AUTOMATED_TESTING: 1,
  EXPERT_REVIEW: 2,
};

const TASK_FORMATS = {
  OFFLINE: 0,
  ONLINE: 1,
};

export default {
  TASK_TYPES,
  TASK_FORMATS,
};
